import { render } from "./ChatMsgSupport.vue?vue&type=template&id=2f1e29e2"
import script from "./ChatMsgSupport.vue?vue&type=script&lang=js"
export * from "./ChatMsgSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/chat/parts/ChatMsgSupport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f1e29e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f1e29e2', __exports__)) {
    api.reload('2f1e29e2', __exports__)
  }
  
  module.hot.accept("./ChatMsgSupport.vue?vue&type=template&id=2f1e29e2", () => {
    api.rerender('2f1e29e2', render)
  })

}


export default __exports__